import _filter from 'lodash/filter';
import _includes from 'lodash/includes';

const DISPLAYED_RANKS = ['LOW', 'MID_LOW'];

export const filterRiskMetrics = metrics => _filter(metrics, m => _includes(DISPLAYED_RANKS, m.rank));
